import React from "react";
import {Layout} from 'antd';

const {Sider} = Layout;

export default props => {

    return (
        <Sider theme={"light"} width={322}>
            {/*<div className="user-photo" style={{*/}
            {/*    display: "flex",*/}
            {/*    color: "#4e4e4e",*/}
            {/*    flexDirection: "column",*/}
            {/*    alignItems: "center",*/}
            {/*    padding: 10*/}
            {/*}}>*/}
            {/*    <UserPhoto/>*/}
            {/*</div>*/}
            {props.children}
        </Sider>
    )
}
